export default __webpack_public_path__ + "static/media/plugins-that-knock.dd2d3b1d.jpg";